<template>
    <el-row>
        <el-col :span="20" :offset="2">
            <el-row>
                <el-col :span="12">
                    <h1 align="left">Customer and CS</h1>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="10" align="right" style="margin-right: 10px;">
                    <el-select placeholder="Filter" disabled>
                    <!-- <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"  disabled>
                        </el-option> -->
                    </el-select>
                </el-col>
                <el-col :span="10" >
                        <el-input placeholder="CUS/SHOP" v-model="input"></el-input>
                </el-col>
            </el-row>
            <el-row style="margin-top: 10px;">
                <el-col :span="10" align="right" style="margin-right: 10px;">
                    <el-button style="width: 51%;">History</el-button>
                </el-col>
                <el-col :span="7"  style="pedding-right: 10px;">
                    <el-select v-model="csName" placeholder="Select" style="width: 100%; ">
                        <el-option
                        v-for="item in this.allCsName"
                        :key="item.name"
                        :label="item.name"
                        :value="item.name">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="2" >
                    <el-button
                        type="primary"
                        @click="updateCustomerCs"
                    >บันทึก</el-button>
                </el-col>
            </el-row>
            <el-table
                ref="OrderList"
                :data="customerCsList"
                :header-cell-style="{
                    'background-color': 'black',
                    color: 'white'
                }"
                style="width: 100%; margin-top: 10px;"
                align="left"
                v-loading="loading"
            >
                <el-table-column label="Cus ID" width="150"
                    ><template slot-scope="scope" align="left">
                        {{ scope.row.user_code }}</template
                    ></el-table-column
                >
                <el-table-column label="Shop" width="300"
                    ><template slot-scope="scope">
                        <p  v-for="item in scope.row.shops" :key="item.id">{{item.name}}</p>
                    </template
                    ></el-table-column
                >
               <el-table-column label="จำนวนเคส" width="150"
                    ><template slot-scope="scope">
                        <p  v-for="item in scope.row.shops" :key="item.id">{{item.pick_up_order_average}}</p>
                    </template
                    ></el-table-column
                >
                <el-table-column label="Mode" width="150"
                    ><template slot-scope="scope">
                       {{ scope.row.mode }}
                    </template
                    ></el-table-column
                >
                <el-table-column :label="previousmonth" width="220"
                    ><template slot-scope="scope">
                       {{ scope.row.previous_customer_support.code }} -  {{ scope.row.previous_customer_support.name }}
                    </template
                    ></el-table-column
                >
                <el-table-column :label="currentmonth" width="220"
                    ><template slot-scope="scope">
                       {{ scope.row.current_customer_support.code }} -  {{ scope.row.current_customer_support.name }}
                    </template
                    ></el-table-column
                >
                <el-table-column :label="nextmonth" width="220"
                    ><template>
                        -
                    </template
                    ></el-table-column
                >
            </el-table>

            <el-col style="margin-top:10px;">
                <el-pagination
                @size-change="changeLimitPage"
                @current-change="changeCurrentPage"
                :current-page.sync="pagination.currentPage"
                :page-sizes="pagination.pageSizes"
                :page-size="10"
                layout="prev, pager, next, sizes"
                :total="pagination.allPage * pagination.limit"
                ></el-pagination>
            </el-col>

        </el-col>
    </el-row>
</template>

<script>
import fgApi from '@/services/fillgoods'

export default {
    name: 'GenerateNotify',
    data () {
        return {
            loading: false,
            previousmonth: '',
            currentmonth: '',
            nextmonth: '',
            allCsName: [],
            csName: '',
            customerCsList: [{
                customer_id: 1
            },
            {
                customer_id: 2
            }
            ],
            pagination: {
                limit: 10,
                offset: 0,
                allPage: 1,
                currentPage: 1,
                pageSizes: [10, 20, 50, 100, 200]
            },
            filterDate: null
        }
    },
    created () {
        this.getdata()
        const today = new Date()
        const pre = new Date()
        pre.setMonth(pre.getMonth() - 1)
        const next = new Date()
        next.setMonth(next.getMonth() + 1)
        this.currentmonth = today.toLocaleString('default', { month: 'long' })
        this.previousmonth = pre.toLocaleString('default', { month: 'long' })
        this.nextmonth = next.toLocaleString('default', { month: 'long' })
    },
    methods: {
        filterNotify () {
            console.log('--------------Customer CS---------------')
        },
        async getdata () {
            var customerCsList = await fgApi.caseTracking.getListCustomerCS()
            this.customerCsList = customerCsList.data.result
            let csName = await fgApi.caseTracking.getListCsProfileAll()
            this.allCsName = csName.data.result
        },
        async updateCustomerCs () {
            let cs = this.allCsName.find(e => e.name === this.csName)
            let body = {
                'customer_support_id': 1,
                'customer_id': cs.customer_support_id
            }
            let respone = await fgApi.caseTracking.updateCustomerCs(body)
            console.log(respone)
        },
        changeLimitPage (val) {
            this.pagination.limit = val
            this.fetchOrder()
        },
        changeCurrentPage (val) {
            this.pagination.offset = this.pagination.currentPage * this.pagination.limit - this.pagination.limit
            this.fetchOrder()
        }
    }
}
</script>
